import { render, staticRenderFns } from "./WapMes.vue?vue&type=template&id=fc1ee828&"
import script from "./WapMes.vue?vue&type=script&lang=js&"
export * from "./WapMes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports